export default __webpack_public_path__ + "static/media/url-shorteningImg_1.0ef13b15.png";